import { Navigate, Outlet } from 'react-router-dom';
import type { ReactElement } from 'react';
import { ROUTES } from '@/app/config/constants';
import { useAppSelector } from '@/app/store/hooks';
import { selectIsSupplierRole } from '@/features/authentication';

/**
 * The Supplier Dashboard is the Supplier role's (2026-10-29, NB-637): any other role is sent to the staff dashboard.
 * The other half, `BuyerDashboardGate` (app/routes), sends a Supplier-role session from the staff dashboard here.
 */
export function SupplierDashboardGate(): ReactElement {
  const isSupplier = useAppSelector(selectIsSupplierRole);
  return isSupplier ? <Outlet /> : <Navigate to={ROUTES.DASHBOARD} replace />;
}
